import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  position: relative;
  display: inline-flex;
  text-align: center;
  width: 100%;
  margin: ${({ theme }) => `${rem(theme.Spacing.Type.Section)} 0`};

  .masonry-asset-grid {
    display: flex;
    width: 100%;
    gap: ${({ theme }) => rem(theme.Grid.Spacing)};
  }
  .masonry-asset-grid-column {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => rem(theme.Grid.Spacing)};
    background-clip: padding-box;
  }
`;
export const StyledDroppableArea = styled.div `
  position: fixed;
  display: ${({ isVisible }) => (isVisible ? 'inline-flex' : 'none')};
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
`;
//# sourceMappingURL=Grid.style.js.map